import { Observable } from 'rxjs';
import { Clinic, DataSourceResponse } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';

@Injectable({ providedIn: 'root' })
export class BranchService extends ApiService {
  endPoint = '/api/branches';
  create(model: Clinic) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
  }
  createForTenant(tenantId: string, model: Clinic) {
    return this.http.post(`${this.clinicsBaseURL}${this.endPoint}/${tenantId}/fortenant`, model);
  }

  update(id: string, model: Clinic) {
    return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.clinicsBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<Clinic> {
    return this.http.get<Clinic>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<Clinic>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
  }
  // getBranchesByTenantId(queryParams: any,tenantId: string):Observable<DataSourceResponse<Clinic>>{
  //   const params = new HttpParamsEncoder().encode(queryParams);

  //   return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
  // }
}
